<template>
  <div id="app">
      <!-- <h1 style="color: white; background: black;">
            Global Voice Control Is Engaged: {{$store.state.isVoiceControlled }}
      </h1> -->
      <transition name="fade" mode="out-in">
            <router-view>
                  <span :="keyboardTriggering"/>
            </router-view>
      </transition>
  </div>
</template>
<script>
import MouseTrap from 'mousetrap';

export default {
name: 'app',
data: () => ({
      //WHAT DEVICE
                  isChrome:                     Boolean,
                  isFirefox:                    Boolean,
                  isSafari:                     Boolean,
                  isOpera:                      Boolean,
                  isIE:                         Boolean,
                  isEdge:                       Boolean,
                  isBlink:                      Boolean,
                  iOS:                          Boolean,
                  AndroidMobile:                Boolean,
      engageVoice: false,
      }),
created(){  
      let ua = window.navigator.userAgent;
            this.isChrome = !!window.chrome && !!window.chrome.webstore;
            this.isFirefox = typeof InstallTrigger !== 'undefined';
            this.isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || safari.pushNotification);
            this.isOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
            this.isIE = /*@cc_on!@*/false || !!document.documentMode;
            this.isEdge = !this.isIE && !!window.StyleMedia;
            this.isBlink = (this.isChrome || this.isOpera) && !!window.CSS,
            this.iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
            this.AndroidMobile = /Android/i.test(navigator.userAgent);

            if (this.isChrome === true){
                // this.$store.state.allowSpeechControl = true;
                this.$router.push('/mobile');
            } else if (this.isFirefox === true){
                this.$router.push('/mobile');  
            } else if (this.AndroidMobile === true 
                    || this.iOS){
                  this.$router.push('/mobile');
            } else if (this.isSafari === true 
                    || this.isOpera === true 
                    || this.isBlink === true 
                    || this.isEdge === true 
                    || this.isIE === true){
                        
            }

            // this.$router.push('/mobile');
            console.log('%c App Created by Matt McCorkle ' , 'background: black; color: gold' , '=> www.mattmccorkle.com');
      },
computed: {
            keyboardTriggering(){
                  Mousetrap.bind('up', ()=> {
                        this.engageVoice = !this.engageVoice;
                              if(this.isChrome){
                                    if (this.engageVoice){
                                          
                                                this.$store.state.allowSpeechControl = true;
                                                this.$store.state.isVoiceControlled = true;
                                    }
                                    else if (!this.engageVoice){
                                                this.$store.state.allowSpeechControl = false;
                                                this.$store.state.isVoiceControlled = false;
                                          
                                    }  
                              }   
                  });     
            }
      }
}           
</script>
<style>
/** ALL SCREEN STYLING                      */
                  html, body {
                  margin:0px;
                  padding:0px;
                  width: 100%;
                  height: 100%;
                  }

                  /*@import url('https://fonts.googleapis.com/css?family=Muli');*/
                  /*@import url('https://fonts.googleapis.com/css?family=Montserrat');*/
                  /*@import url('https://fonts.googleapis.com/css?family=Tajawal');*/
                  @import url('https://fonts.googleapis.com/css?family=Quicksand');

                  #app{
                  font-family: Avenir, Quicksand;
                  /*font-weight: 300;*/
                  -webkit-font-smoothing: antialiased;
                  -moz-osx-font-smoothing: grayscale;
                  text-align: center;
                  margin:0px;
                  padding:0px;
                  }
                  button:focus {outline:none !important;}
                  input:focus {outline:none !important;}
                  
                  .container-fluid{
                  padding-right: 0px;
                  padding-left: 0px;
                  }
                  /* DO NOT ALLOW CLICK OF RANGE TRACK */
                  input[type=range] {
                  pointer-events: none;
                  }

                  input[type=range]::-webkit-slider-thumb {
                  pointer-events:auto;
                  }
/** BACKGROUND DEFAULTS                     */
                  body.default {
                      background-color: white;
                  }
                  body.plains {
                      background-color: #e0a01f;
                  }
                  body.ocean {
                      background-color: white;
                  }
                  body.amazon {
                      background-color: #4f601f;
                  }
                  body.forest {
                      background-color: #8fd471;
                  }
                  body.desert {
                      background-color: #9a6d32;
                  }
                  body.beach {
                      background-color: #e4c39a;
                  }
                  body.nyc {
                      background-color: #f1f3f3;
                  }
                  body.rural {
                      background-color: #669999;
                  }
                  body.ice {
                      background-color: #13c4ec;
                  }
                  body.fire {
                      background-color: #ff0000;
                  }
                  body.tutorial {
                      background-color: #000000;
                  }
/** STYLINGS FOR VERY SMALL SCREENS < 350px */
      @media (min-width: 0px)  and (max-width: 349px) {
                  #mainDiv{
                  padding-right: 0px;
                  padding-left: 0px;
                  max-width: 400px; 
                  height: 800px;    
                  }
            /* WELCOME                     */
                  #optionsBucket{
                  margin-top: 5px;
                  } 
                  #enterContainer{
                  margin-top: 30px;
                  }
                  #mobileBtn{
                  margin-top: 150px;
                  border-width: 2px;
                  font-size: 24px;
                  font-weight: 300;
                  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);
                  }
                  #welcomeMobileText{
                  margin-top: 20px;
                  color: black;
                  font-size: 16px;
                  font-weight: 300;
                  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);
                  }
                  #bell{
                  color: var(--main-v1-color);      
                  }
                  #enterFuncBtn{
                  font-size: 22px;
                  height: 200px;
                  width: 200px;
                  border-radius: 300px;
                  margin-top: 100px;
                  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);
                  }
                  #welcomeBtn{
                  height: 40px;
                  width: 250px;
                  margin-top: 4px;
                  margin-left: 0px;
                  font-size: 18px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  #welcomeBtnAbout{
                  height: 40px;
                  width: 250px;
                  margin-top: 4px;
                  margin-left: -2px;
                  font-size: 18px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
            /* ABOUT                       */
                  #helpContainer{
                  margin-top: 0px;      
                  }
                  #helpContainerTutorial{
                  max-width: 144px;
                  margin-top: 15px; 
                  margin-left: 74px;    
                  }
                  #aboutBtnID{
                  margin-top: 0px;
                  width: 70px;
                  font-size: 11px;
                  border-radius: 6px;
                  padding: 6px 0px;
                  font-weight: 700;
                  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.4);
                  }
                  #localStorageBtnID{
                  margin-top: 0px;
                  width: 70px;
                  font-size: 11px;
                  border-radius: 6px;
                  padding: 6px 0px;
                  font-weight: 700;
                  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.4);      
                  }
                  #aboutBtnID2{
                  margin-top:-12px;
                  /*font-size: 30px;*/
                  border-radius: 6px;
                  padding: 5px 8px;
                  font-weight: 300;
                  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.4);
                  }
                  #aboutPageID{
                  
                  }
                  #aboutTxt{
                  max-width: 320px;
                  margin: auto;
                  margin-top: 18px;
                  font-size: 13px;
                  text-align: left;
                  color: white;
                  text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.2);
                  }
                  #shoutOut{
                  font-size: 12px;      
                  }
                  #disclaimerTxt{
                  margin-top: 10px;
                  font-size: 10px;
                  text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.2);
                  }
                  #aboutSectionVO{
                  margin-top: -10px;
                  margin-bottom: -6px; 
                  width: 180px;
                  border-radius: 4px;
                  font-size: 15px;
                  font-weight: 400;   
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.4); 
                  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);  
                  margin-left: -1px;     
                  }
            /* MISSON CONTROL              */
                  #fxTitle{
                  font-weight: 300;
                  font-size: 20px;
                  color:white;  
                  margin-top: 4px;
                  margin-bottom: 0px;
                  text-shadow: 0px 1px 3px rgba(0, 0, 0, 0.5);
                  }
                  #fxTitle2{
                  font-weight: 300;
                  font-size: 12px;
                  color:white;  
                  margin-top: 280px;
                  margin-bottom: -20px;
                  }
                  #fxTutorialTitle{
                  font-weight: 300;
                  font-size: 22px;
                  color:white;  
                  margin-top: 8px;
                  margin-bottom: 10px;      
                  }
                  #fxTutorialTitle2{
                  font-weight: 300;
                  font-size: 20px;
                  color:white;  
                  margin-top: 20px;
                  margin-bottom: 10px;      
                  }
                  #fxTutorialTitle3{
                  font-weight: 300;
                  font-size: 12px;
                  color:white;  
                  margin-top: 290px;
                  margin-bottom: -20px;      
                  }
                  #controlsContainer{
                  max-width: 400px;
                  margin: auto;
                  margin-top: 0px;
                  margin-bottom: -40px;
                  }
                  #masterControlDiv{
                  margin-top: 180px;
                  margin-left: 0px;
                  margin-bottom: 0px;
                  max-width: 1500px;
                  }
                  #masterControlBadges{
                  margin-top: -16px;
                  border-radius: 6px;
                  padding: 8px 8px;
                  font-size: 14px;
                  font-weight: 700;
                  width: 150px;
                  border: 2px solid transparent;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.4);
                  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);
                  }
                  #masterControlBadgesSFX{
                  margin-top: -16px;
                  margin-bottom: 0px;
                  border-radius: 6px;
                  padding: 8px 8px;
                  font-size: 14px;
                  font-weight: 700;
                  width: 150px;
                  border: 2px solid transparent;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.4);
                  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);
                  }
                  #voice6SliderDiv{
                  width: 100%;
                  margin-top: 40px;
                  }
                  #voice1SliderDiv{
                  margin-top: 40px;
                  width: 100%;
                  }
                  /*#voice1SliderDiv{
                  margin-top: 40px;
                  width: 100%;
                  }
                  #voice2SliderDiv{
                  margin-top: 40px;
                  width: 50%;
                  content: '\A';
                  white-space: pre;      
                  }
                  #voice3SliderDiv{
                  margin-top: 20px;
                  width: 50%;
                  content: '\A';
                  white-space: pre;      
                  }
                  #voice4SliderDiv{
                  margin-top: 20px;
                  width: 50%;
                  content: '\A';
                  white-space: pre;      
                  }
                  #voice5SliderDiv{
                  margin-top: 30px;
                  width: 50%;
                  content: '\A';
                  white-space: pre;
                  }
                  #voice6SliderDiv{
                  width: 50%;
                  content: '\A';
                  white-space: pre; 
                  margin-top: 30px;
                  }*/
                  #sliders1{
                  margin-top: 20px;
                  }
                  #sliders2{
                  margin-top: 20px;
                  }
                  #sliders3{
                  margin-top: 20px;
                  }
                  #sliders4{
                  margin-top: 20px;
                  }
                  #sliders5{
                  margin-top: 20px;
                  }
                  #sliders6{
                  height: 10px;
                  width: 250px;
                  margin-top: 16px;      
                  }
            /* AMBIANCE BUTTONS            */
                  #ambienceBtnLocation{
                  max-width: 400px;
                  margin: auto;
                  margin-top: 0px;
                  margin-bottom: 0px;
                  margin-left: -6px;
                  }
                  #ambienceBtns{
                  width: 140px;
                  border-radius: 4px;
                  font-size: 14px;
                  font-weight: 700;   
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.4); 
                  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);  
                  margin-left: -1px;
                  }
                  #tutorialContainer{
                  max-width: 500px;
                  margin: auto;
                  margin-top: 10px;
                  margin-bottom: 10px; 
                  margin-left: -5px;
                  }
                  #helpBtn1Div{
                  width: 50%;
                  /*content: '\A';*/
                  /*white-space: pre; */
                  margin-top: 0px;
                  margin-bottom: 6px;
                  }
                  #helpBtn2Div{
                  width: 50%;
                  /*content: '\A';*/
                  /*white-space: pre; */
                  margin-top: 0px;
                  margin-bottom: 6px;
                  }
                  #helpBtn3Div{
                  width: 50%;
                  /*content: '\A';*/
                  /*white-space: pre; */
                  margin-top: 6px;
                  }
                  #helpBtn4Div{
                  width: 50%;
                  /*content: '\A';*/
                  /*white-space: pre; */
                  margin-top: 6px;
                  }
                  #ambienceBtn1Div{
                  width: 50%;
                  /*content: '\A';*/
                  /*white-space: pre;*/
                  margin-bottom: 30px;
                  }
                  #ambienceBtn2Div{
                  width: 50%;
                  /*content: '\A';*/
                  /*white-space: pre;*/
                  margin-bottom: 30px;
                  }
                  #ambienceBtn3Div{
                  width: 50%;
                  content: '\A';
                  /*white-space: pre;*/
                  }
                  #ambienceBtn4Div{
                  width: 50%;
                  content: '\A';
                  /*white-space: pre;*/
                  }
                  #ambienceBtn5Div{
                  width: 50%;
                  /*content: '\A';*/
                  /*white-space: pre; */
                  margin-top: 30px;     
                  }
                  #ambienceBtn6Div{
                  width: 50%;
                  /*content: '\A';*/
                  /*white-space: pre; */
                  margin-top: 30px;      
                  }
                  #ambienceSlider{
                  margin-top: 18px;
                  /*margin-left: 10px;*/
                  }
                  #ambienceBadges{
                  font-size: 22px;
                  background-color:var(--main-time-color);
                  color: black; 
                  }
                  #exploreBtnId{
                  margin-top: 15px;
                  height: 40px;
                  width: 140px;
                  border-radius: 5px;
                  font-size: 18px;
                  font-weight: 700;            
                  }
            /* RANGER                      */
                  input[type="range"]{
                  -webkit-appearance: none;
                  height: 6px;
                  width: 120px;
                  border-radius: 20px;
                  margin: auto;
                  border: 0px dotted transparent; 
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.2);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.2);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.2);
                  }
                  input[type="range"]::-moz-range-track{
                  -webkit-appearance: none;
                  height: 6px;
                  width: 120px;
                  border-radius: 20px;
                  margin: auto;
                  border: 0px dotted transparent;  
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.2);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.2);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.2);
                  }
                  input[type="range"]::-webkit-slider-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 35px;
                  height: 35px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  border: 0px dotted transparent;  
                  }
                  input[type="range"]::-moz-range-thumb{
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 35px;
                  height: 35px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  border: 0px dotted transparent;  
                  } 
            /* MAILING LIST                */
                  #mailingListText{
                  margin: auto;
                  max-width: 300px;
                  margin-top: 10px;
                  margin-bottom: 6px;
                  font-size: 14px;      
                  }
                  #mce-EMAIL{
                  font-size:12px; 
                  padding: 4px 10px;
                  margin-top: 0px;  
                  width: 160px;
                  border-width: 1px;
                  border-radius: 4px;
                  background-color: transparent;
                  border-color: black;
                  }
                  #mc-embedded-subscribe{
                  width: 100px;
                  font-size:14px; 
                  padding: 2px 10px;
                  margin-top: 8px;
                  margin-bottom: -20px;
                  border-width: 1px;
                  border-radius: 4px;
                  background-color: transparent;
                  border-color: black;
                  }
      }
/** STYLINGS FOR SMALLER SCREENS < 600px   */
      @media (min-width: 350px) and (max-width: 600px) {
                  #mainDiv{
                  padding-right: 0px;
                  padding-left: 0px;
                  max-width: 2000px;  
                  height: 1000px; 
                  }
            /* WELCOME                     */
                  #optionsBucket{
                  margin-top: 5%;
                  } 
                  #enterContainer{
                  margin-top: 30px;
                  }
                  #mobileBtn{
                  margin-top: 150px;
                  border-width: 2px;
                  font-size: 26px;
                  font-weight: 300;
                  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);
                  }
                  #welcomeMobileText{
                  margin-top: 20px;
                  color: black;
                  font-size: 18px;
                  font-weight: 300;
                  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);
                  }
                  #bell{
                  color: var(--main-v1-color);      
                  }
                  #enterFuncBtn{
                  font-size: 23px;
                  height: 200px;
                  width: 200px;
                  border-radius: 300px;
                  margin-top: 100px;
                  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);
                  }
                  #welcomeBtn{
                  height: 50px;
                  width: 300px;
                  margin-top: 4px;
                  margin-left: 0px;
                  font-size: 24px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  #welcomeBtnAbout{
                  height: 50px;
                  width: 300px;
                  margin-top: 4px;
                  margin-left: 0px;
                  font-size: 24px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
            /* ABOUT                       */
                  #helpContainer{
                  max-width: 235px;
                  margin-top: 20px;      
                  }
                  #helpContainerTutorial{
                  max-width: 235px;
                  margin-top: 20px;     
                  }
                  #aboutBtnID{
                  width: 80px;
                  margin-top: 0px;
                  font-size: 14px;
                  border-radius: 6px;
                  font-weight: 700;
                  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.4);
                  }
                  #localStorageBtnID{
                  width: 80px;
                  margin-top: 0px;
                  font-size: 16px;
                  border-radius: 6px;
                  font-weight: 700;
                  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.4);      
                  }
                  #aboutBtnID2{
                  margin-top: -10px;
                  /*font-size: 30px;*/
                  border-radius: 6px;
                  padding: 5px 8px;
                  font-weight: 300;
                  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.4);
                  }
                  #aboutPageID{
                  
                  }
                  #aboutTxt{
                  margin: auto;
                  margin-top: 32px;
                  font-size: 16px;
                  text-align: left;
                  color: white;
                  text-shadow: 0px 2px 2px rgba(0, 0, 0, 0.2);
                  }
                  #shoutOut{
                  font-size: 14px;      
                  }
                  #disclaimerTxt{
                  margin-top: 20px;
                  font-size: 12px;
                  text-shadow: 0px 2px 2px rgba(0, 0, 0, 0.2);
                  }
                  #aboutSectionVO{
                  margin-top: -15px;
                  margin-bottom: -20px; 
                  width: 200px;
                  border-radius: 4px;
                  font-size: 18px;
                  /*font-weight: 500;  */
                  padding: 5px 4px; 
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.4);
                  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);      
                  }
            /* MISSON CONTROL              */
                  #fxTitle{
                  font-weight: 300;
                  font-size:26px;
                  color:white;  
                  margin-top: 6px;
                  margin-bottom: 6px;
                  text-shadow: 0px 1px 3px rgba(0, 0, 0, 0.5);
                  }
                  #fxTitle2{
                  font-weight: 300;
                  font-size:14px;
                  color:white;  
                  margin-top: 330px;
                  margin-bottom: -30px;
                  }
                  #fxTutorialTitle{
                  font-weight: 300;
                  font-size: 22px;
                  color:white;  
                  margin-top: 8px;
                  margin-bottom: 10px;      
                  }
                  #fxTutorialTitle2{
                  font-weight: 300;
                  font-size: 20px;
                  color:white;  
                  margin-top: 20px;
                  margin-bottom: 10px;      
                  }
                  #fxTutorialTitle3{
                  font-weight: 300;
                  font-size: 15px;
                  color:white;  
                  margin-top: 360px;
                  margin-bottom: -30px;      
                  }
                  #controlsContainer{
                  max-width: 400px;
                  margin: auto;
                  margin-top: 4px;
                  margin-bottom: -50px;
                  }
                  #masterControlDiv{
                  margin-top: 0px;
                  margin-bottom: 0px;
                  max-width: 1500px;
                  }
                  #masterControlBadges{
                  border-radius: 6px;
                  padding: 8px 8px;
                  font-size: 18px;
                  font-weight: 700;
                  width: 175px;
                  border: 2px solid transparent;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.4);
                  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);
                  }
                  #masterControlBadgesSFX{
                  margin-top: -5px;
                  border-radius: 6px;
                  padding: 8px 8px;
                  font-size: 22px;
                  font-weight: 500;
                  width: 200px;
                  border: 2px solid transparent;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.4);
                  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);
                  }
                  #voice6SliderDiv{
                  width: 100%;
                  margin-top: 40px;
                  }
                  #voice1SliderDiv{
                  margin-top: 40px;
                  width: 100%;
                  }
                  #voice2SliderDiv{
                  /*margin-top: 40px;
                  width: 50%;
                  content: '\A';
                  white-space: pre;   */   
                  }
                  #voice3SliderDiv{
                  /*margin-top: 20px;
                  width: 50%;
                  content: '\A';
                  white-space: pre;    */  
                  }
                  #voice4SliderDiv{
                  /*margin-top: 20px;
                  width: 50%;
                  content: '\A';
                  white-space: pre;      */
                  }
                  #voice5SliderDiv{
                  /*margin-top: 30px;
                  width: 50%;
                  content: '\A';
                  white-space: pre;*/
                  }
                  #sliders1{
                  margin-top: 20px;
                  }
                  #sliders2{
                  margin-top: 20px;
                  }
                  #sliders3{
                  margin-top: 20px;
                  }
                  #sliders4{
                  margin-top: 20px;
                  }
                  #sliders5{
                  margin-top: 20px;
                  }
                  #sliders6{
                  height: 10px;
                  width: 250px;
                  margin-top: 30px;      
                  }
            /* AMBIANCE BUTTONS            */
                  #ambienceBtnLocation{
                  max-width: 400px;
                  margin: auto;
                  margin-top: 0px;
                  margin-bottom: 0px;
                  margin-left: -2px;
                  }
                  #ambienceBtns{
                  width: 165px;
                  border-radius: 4px;
                  font-size: 18px;
                  font-weight: 700;  
                  margin-bottom: 5px;
                  margin-left: -2.5px; 
                  padding: 8px 0px; 
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.4);
                  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);    
                  text-align: center;
                  }
                  #ambienceTxtID{
                  /*margin-left: 10px;         */
                  }
                  #tutorialContainer{
                  max-width: 600px;
                  margin: auto;
                  margin-top: 0px;
                  margin-bottom: 0px; 
                  margin-left: -2px;
                  }
                  #helpBtn1Div{
                  width: 50%;
                  /*content: '\A';*/
                  /*white-space: pre; */
                  margin-top: 0px;
                  margin-bottom: 10px;
                  }
                  #helpBtn2Div{
                  width: 50%;
                  /*content: '\A';*/
                  /*white-space: pre; */
                  margin-top: 0px;
                  margin-bottom: 10px;
                  }
                  #helpBtn3Div{
                  width: 50%;
                  /*content: '\A';*/
                  /*white-space: pre; */
                  margin-top: 4px;
                  }
                  #helpBtn4Div{
                  width: 50%;
                  /*content: '\A';*/
                  /*white-space: pre; */
                  margin-top: 4px;
                  }
                  #ambienceBtn1Div{
                  width: 50%;
                  content: '\A';
                  white-space: pre;
                  margin-bottom: 30px;
                  }
                  #ambienceBtn2Div{
                  width: 50%;
                  content: '\A';
                  white-space: pre;
                  margin-bottom: 30px;
                  }
                  #ambienceBtn3Div{
                  width: 50%;
                  content: '\A';
                  white-space: pre;
                  }
                  #ambienceBtn4Div{
                  width: 50%;
                  content: '\A';
                  white-space: pre;
                  }
                  #ambienceBtn5Div{
                  width: 50%;
                  content: '\A';
                  white-space: pre; 
                  margin-top: 30px;     
                  }
                  #ambienceBtn6Div{
                  width: 50%;
                  content: '\A';
                  white-space: pre; 
                  margin-top: 30px;      
                  }
                  #ambienceSlider{
                  margin-top: 20px;
                  margin-left: 5px;
                  }
                  #ambienceBadges{
                  font-size: 22px;
                  background-color:var(--main-time-color);
                  color: black; 
                  }
                  #exploreBtnId{
                  margin-top: 20px;
                  height: 40px;
                  width: 200px;
                  border-radius: 5px;
                  font-size: 22px;
                  font-weight: 500;            
                  }
            /* RANGER                      */
                  input[type="range"]{
                  -webkit-appearance: none;
                  height: 10px;
                  width: 145px;
                  border-radius: 20px;
                  margin: auto;
                  border: 0px dotted transparent; 
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.2);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.2);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.2);
                  }
                  input[type="range"]::-moz-range-track{
                  -webkit-appearance: none;
                  height: 10px;
                  width: 145px;
                  border-radius: 20px;
                  margin: auto;
                  border: 0px dotted transparent;  
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.2);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.2);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.2);
                  }
                  input[type="range"]::-webkit-slider-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 45px;
                  height: 45px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  border: 0px dotted transparent;  
                  }
                  input[type="range"]::-moz-range-thumb{
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 45px;
                  height: 45px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  border: 0px dotted transparent;  
                  } 
            /* MAILING LIST                */
                  #mailingListText{
                  margin: auto;
                  max-width: 300px;
                  margin-top: 10px;
                  margin-bottom: 6px;
                  font-size: 14px;      
                  }
                  #mce-EMAIL{
                  font-size:14px; 
                  padding: 4px 10px;
                  margin-top: 0px;  
                  width: 190px;
                  border-width: 1px;
                  border-radius: 4px;
                  background-color: transparent;
                  border-color: black;
                  }
                  #mc-embedded-subscribe{
                  width: 120px;
                  font-size:14px; 
                  padding: 4px 10px;
                  margin-top: 8px;
                  margin-bottom: -20px;
                  border-width: 1px;
                  border-radius: 4px;
                  background-color: transparent;
                  border-color: black;
                  }
      }
/** STYLINGS FOR MEDIUM SCREENS < 768px   */
      @media (min-width: 601px) and (max-width: 800px) {
                  #mainDiv{
                  padding-right: 0px;
                  padding-left: 0px;
                  max-width: 2000px; 
                  height: 2000px;    
                  }
            /* WELCOME                     */
                  #optionsBucket{
                  margin-top: 15%;
                  } 
                  #enterContainer{
                  margin-top: 30px;
                  }
                  #mobileBtn{
                  margin-top: 250px;
                  border-width: 2px;
                  font-size: 36px;
                  font-weight: 300;
                  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);
                  }
                  #welcomeMobileText{
                  max-width: 500px;
                  margin: auto;
                  margin-top: 20px;
                  color: black;
                  font-size: 26px;
                  font-weight: 300;
                  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);
                  }
                  #bell{
                  color: var(--main-v1-color);      
                  }
                  #enterFuncBtn{
                  font-size: 35px;
                  height: 300px;
                  width: 300px;
                  border-radius: 300px;
                  margin-top: 180px;
                  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);
                  }
                  #welcomeBtn{
                  height: 80px;
                  width: 350px;
                  margin-top: 10px;
                  margin-left: 0px;
                  font-size: 33px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  #welcomeBtnAbout{
                  height: 80px;
                  width: 704px;
                  margin-top: 10px;
                  margin-left: -2px;
                  font-size: 40px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
            /* ABOUT                       */
                  #helpContainer{
                  max-width: 260px;
                  margin-top: 0px;      
                  }
                  #helpContainerTutorial{
                  max-width: 260px;
                  margin-top: 0px;        
                  }
                  #aboutBtnID{
                  height: 50px;
                  width: 90px;
                  margin-top: 20px;
                  font-size: 16px;
                  border-radius: 6px;
                  font-weight: 700;
                  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
                  }
                  #localStorageBtnID{
                  height: 50px;
                  width: 90px;
                  margin-top: 20px;
                  font-size: 18px;
                  border-radius: 6px;
                  font-weight: 700;
                  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);      
                  }
                  #aboutBtnID2{
                  padding: 5px 8px;
                  font-weight: 300;
                  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
                  }
                  #aboutPageID{
                  margin-top: 20%;
                  }
                  #aboutTxt{
                  max-width: 720px;
                  margin: auto;
                  font-size: 18px;
                  text-align: left;
                  color: white;
                  }
                  #shoutOut{
                  font-size: 16px;      
                  }
                  #disclaimerTxt{
                  margin-top: 30px;
                  font-size: 14px;
                  }
                  #aboutSectionVO{
                  margin-top: -10px;
                  margin-bottom: 20px;   
                  width: 220px;
                  border-radius: 6px;
                  font-size: 20px;
                  font-weight: 400; 
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.4);
                  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);     
                  }
            /* MISSON CONTROL              */
                  #fxTitle{
                  font-weight: 300;
                  font-size: 45px;
                  color:white;  
                  margin-top: 80px;
                  margin-bottom: 4px;
                  text-shadow: 0px 1px 3px rgba(0, 0, 0, 0.5);
                  }
                  #fxTitle2{
                  font-weight: 300;
                  font-size:14px;
                  color:white;  
                  margin-top: 330px;
                  margin-bottom: -30px;
                  }
                  #fxTutorialTitle{
                  font-weight: 300;
                  font-size: 35px;
                  color:white;  
                  margin-top: 20px;
                  margin-bottom: 0px;      
                  }
                  #fxTutorialTitle2{
                  font-weight: 300;
                  font-size: 35px;
                  color:white;  
                  margin-top: 30px;
                  margin-bottom: 10px;      
                  }
                  #fxTutorialTitle3{
                  font-weight: 300;
                  font-size: 25px;
                  color:white;  
                  margin-top: 320px;
                  margin-bottom: -80px;      
                  }
                  #controlsContainer{
                  max-width: 1000px;
                  margin: auto;
                  margin-top: 0%;
                  margin-bottom: 50px;
                  }
                  #masterControlDiv{
                  margin-top: 0px;
                  margin-left: 0px;
                  margin-bottom: 0px;
                  }
                  #masterControlBadges{
                  margin-top: -10px;
                  padding: 8px 5px;
                  font-size: 22px;
                  font-weight: 700;
                  width: 220px;
                  border: 2px solid transparent;
                  border-radius: 5px;
                   -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.4);
                  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3); 
                  }
                  #masterControlBadgesSFX{
                  margin-top: 30px;
                  margin-bottom: -14px;
                  padding: 8px 5px;
                  font-size: 26px;
                  font-weight: 500;
                  width: 220px;
                  border: 2px solid transparent;
                  border-radius: 5px;
                   -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.4); 
                  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);
                  }
                  #masterTimingBadges{
                  padding: 8px 8px;
                  font-size: 17px;
                  font-weight: 700;
                  background-color: var(--main-time-color);
                  color: black; 
                  width: 150px;
                  border: 2px solid transparent;
                  border-radius: 5px;
                  }
                  #voice1SliderDiv{
                  margin-top: 100px;
                  width: 100%;
                  }
                  #voice6SliderDiv{
                  width: 100%;
                  margin-top: 40px;
                  }
                  #voice2SliderDiv{
                  
                  }
                  #voice3SliderDiv{
                 
                  }
                  #voice4SliderDiv{
                 
                  }
                  #voice5SliderDiv{
                  
                  }
                  /*#sliders1{
                  margin-top: 30px;
                  }
                  #sliders2{
                  margin-top: 30px;
                  }
                  #sliders3{
                  margin-top: 30px;
                  }
                  #sliders4{
                  margin-top: 30px;
                  }
                  #sliders5{
                  margin-top: 30px;      
                  }*/
                  #sliders6{
                  margin-top: 30px;   
                  width: 220px;   
                  }
            /* AMBIANCE BUTTONS            */
                  #ambienceBtnLocation{
                  max-width: 1000px;
                  margin: auto;
                  margin-top: 0px;
                  margin-bottom: 0px;
                  }
                  #ambienceBtns{
                  width: 220px;
                  border-radius: 6px;
                  font-size: 22px;
                  font-weight: 700; 
                  margin-top: 20px;    
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.4);
                  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);  
                  }
                  #tutorialContainer{
                  max-width: 500px;
                  margin: auto;
                  margin-top: 0px;
                  margin-bottom: -80px; 
                  }
                  #helpBtn1Div{
                  width: 50%;
                  /*content: '\A';*/
                  /*white-space: pre; */
                  margin-top: 0px;
                  }
                  #helpBtn2Div{
                  width: 50%;
                  /*content: '\A';*/
                  /*white-space: pre; */
                  margin-top: 0px;
                  }
                  #helpBtn3Div{
                  width: 50%;
                  /*content: '\A';*/
                  /*white-space: pre; */
                  margin-top: 0px;
                  }
                  #helpBtn4Div{
                  width: 50%;
                  /*content: '\A';*/
                  /*white-space: pre; */
                  margin-top: 0px;
                  }
                  #ambienceBtn1Div{
                  width: 33%;
                  }
                  #ambienceBtn2Div{
                  width: 33%;
                  }
                  #ambienceBtn3Div{
                  width: 33%;
                  }
                  #ambienceBtn4Div{
                  width: 33%;
                  content: '\A';
                  white-space: pre; 
                  margin-top: 30px; 
                  }
                  #ambienceBtn5Div{
                  width: 33%;
                  content: '\A';
                  white-space: pre; 
                  margin-top: 30px;     
                  }
                  #ambienceBtn6Div{
                  width: 33%;
                  content: '\A';
                  white-space: pre; 
                  margin-top: 30px;      
                  }
                  #ambienceSlider{
                  margin-top: 30px;
                  }
                  #ambienceBadges{
                  font-size: 22px;
                  background-color:var(--main-time-color);
                  color: black; 
                  }
                  #exploreBtnId{
                  margin-top: 32px;
                  height: 50px;
                  width: 220px;
                  border-radius: 5px;
                  font-size: 22px;
                  font-weight: 700;            
                  }
            /* RANGER                      */
                  input[type="range"]{
                  -webkit-appearance: none;
                  height: 10px;
                  width: 180px;
                  border-radius: 20px;
                  margin: auto;
                  border: 0px dotted transparent;  
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.2);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.2);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.2); 
                  }
                  input[type="range"]::-moz-range-track{
                  -webkit-appearance: none;
                  height: 10px;
                  width: 180px;
                  border-radius: 20px;
                  margin: auto;
                  border: 0px dotted transparent;  
                   -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.2);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.2);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.2); 
                  }
                  input[type="range"]::-webkit-slider-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 50px;
                  height: 50px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  border: 0px dotted transparent;  
                  }
                  input[type="range"]::-moz-range-thumb{
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 50px;
                  height: 50px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  border: 0px dotted transparent;  
                  } 
            /* MAILING LIST                */
                  #mailingListText{
                  margin-top: 20px;
                  margin-bottom: 0px;
                  font-size: 18px;   
                  }
                  #mce-EMAIL{
                  font-size:16px; 
                  padding: 4px 10px;
                  margin-top: 0px;  
                  width: 250px;
                  border-width: 1px;
                  border-radius: 6px;
                  background-color: transparent;
                  border-color: black;
                  }
                  #mc-embedded-subscribe{
                  font-size:16px; 
                  padding: 4px 10px;
                  margin-top: 6px;
                  border-width: 1px;
                  border-radius: 6px;
                  background-color: transparent;
                  border-color: black;
                  } 
      }
/** STYLINGS FOR TABLET SCREENS  < 1025px   */
      @media (min-width: 801px) and (max-width: 1024px){
                  #mainDiv{
                  padding-right: 0px;
                  padding-left: 0px;
                  max-width: 2000px;   
                  height: 1500px;  
                  }
            /* WELCOME                     */
                  #optionsBucket{
                  margin-top: 15%;
                  } 
                  #enterContainer{
                  margin-top: 30px;
                  }
                  #mobileBtn{
                  margin-top: 250px;
                  border-width: 2px;
                  font-size: 36px;
                  font-weight: 300;
                  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);
                  }
                  #welcomeMobileText{
                  max-width: 500px;
                  margin: auto;
                  margin-top: 20px;
                  color: black;
                  font-size: 26px;
                  font-weight: 300;
                  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);
                  }
                  #bell{
                  color: var(--main-v1-color);      
                  }
                  #enterFuncBtn{
                  font-size: 50px;
                  height: 400px;
                  width: 400px;
                  border-radius: 400px;
                  margin-top: 230px;
                  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);
                  }
                  #welcomeBtn{
                  height: 100px;
                  width: 450px;
                  margin-top: 10px;
                  margin-left: 0px;
                  font-size: 45px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  #welcomeBtnAbout{
                  height: 100px;
                  width: 904px;
                  margin-top: 10px;
                  margin-left: -2px;
                  font-size: 45px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
            /* ABOUT                       */
                  #helpContainer{
                  max-width: 368px;
                  margin-top: 0px;      
                  }
                  #helpContainerTutorial{
                  max-width: 366px;
                  margin-top: 0px;        
                  }
                  #aboutBtnID{
                  height: 60px;
                  width: 115px;
                  margin-top: 25px;
                  font-size: 22px;
                  border-radius: 6px;
                  font-weight: 700;
                  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
                  }
                  #localStorageBtnID{
                  height: 60px;
                  width: 115px;
                  margin-top: 25px;
                  font-size: 24px;
                  border-radius: 6px;
                  font-weight: 700;
                  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);      
                  }
                  #aboutBtnID2{
                  padding: 5px 8px;
                  font-weight: 300;
                  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
                  }
                  #aboutPageID{
                  margin-top: 20%;
                  }
                  #aboutTxt{
                  max-width: 720px;
                  margin: auto;
                  font-size: 18px;
                  text-align: left;
                  color: white;
                  }
                  #shoutOut{
                  font-size: 16px;      
                  }
                  #disclaimerTxt{
                  margin-top: 30px;
                  font-size: 14px;
                  }
                  #aboutSectionVO{
                  margin-top: -10px;
                  margin-bottom: 20px;   
                  width: 220px;
                  border-radius: 6px;
                  font-size: 20px;
                  font-weight: 400; 
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.4);
                  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);     
                  }
            /* MISSON CONTROL              */
                  #fxTitle{
                  font-weight: 300;
                  font-size: 55px;
                  color:white;  
                  margin-top: 160px;
                  margin-bottom: 4px;
                  text-shadow: 0px 1px 3px rgba(0, 0, 0, 0.5);
                  }
                  #fxTitle2{
                  font-weight: 300;
                  font-size:14px;
                  color:white;  
                  margin-top: 330px;
                  margin-bottom: -30px;
                  }
                  #fxTutorialTitle{
                  font-weight: 300;
                  font-size: 35px;
                  color:white;  
                  margin-top: 20px;
                  margin-bottom: 0px;      
                  }
                  #fxTutorialTitle2{
                  font-weight: 300;
                  font-size: 35px;
                  color:white;  
                  margin-top: 30px;
                  margin-bottom: 10px;      
                  }
                  #fxTutorialTitle3{
                  font-weight: 300;
                  font-size: 30px;
                  color:white;  
                  margin-top: 380px;
                  margin-bottom: -60px;      
                  }
                  #controlsContainer{
                  max-width: 1000px;
                  margin: auto;
                  margin-top: 0%;
                  margin-bottom: 50px;
                  }
                  #masterControlDiv{
                  margin-top: 0px;
                  margin-left: 0px;
                  margin-bottom: 0px;
                  }
                  #masterControlBadges{
                  margin-top: -20px;
                  padding: 8px 5px;
                  font-size: 26px;
                  font-weight: 700;
                  width: 300px;
                  border: 2px solid transparent;
                  border-radius: 5px;
                   -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.4);
                  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3); 
                  }
                  #masterControlBadgesSFX{
                  margin-top: 30px;
                  margin-bottom: -14px;
                  padding: 8px 5px;
                  font-size: 32px;
                  font-weight: 500;
                  width: 300px;
                  border: 2px solid transparent;
                  border-radius: 5px;
                   -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.4); 
                  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);
                  }
                  #masterTimingBadges{
                  padding: 8px 8px;
                  font-size: 17px;
                  font-weight: 700;
                  background-color: var(--main-time-color);
                  color: black; 
                  width: 150px;
                  border: 2px solid transparent;
                  border-radius: 5px;
                  }
                  #voice1SliderDiv{
                  margin-top: 100px;
                  width: 100%;
                  }
                  #voice6SliderDiv{
                  width: 100%;
                  margin-top: 40px;
                  }
                  #voice2SliderDiv{
                  
                  }
                  #voice3SliderDiv{
                 
                  }
                  #voice4SliderDiv{
                 
                  }
                  #voice5SliderDiv{
                  
                  }
                  /*#sliders1{
                  margin-top: 30px;
                  }
                  #sliders2{
                  margin-top: 30px;
                  }
                  #sliders3{
                  margin-top: 30px;
                  }
                  #sliders4{
                  margin-top: 30px;
                  }
                  #sliders5{
                  margin-top: 30px;      
                  }*/
                  #sliders6{
                  margin-top: 30px;   
                  width: 300px;   
                  }
            /* AMBIANCE BUTTONS            */
                  #ambienceBtnLocation{
                  max-width: 1000px;
                  margin: auto;
                  margin-top: 0px;
                  margin-bottom: 0px;
                  }
                  #ambienceBtns{
                  width: 300px;
                  height: 70px;
                  border-radius: 6px;
                  font-size: 30px;
                  font-weight: 700; 
                  margin-top: 20px;    
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.4);
                  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);  
                  }
                  #tutorialContainer{
                  max-width: 700px;
                  margin: auto;
                  margin-top: 0px;
                  margin-bottom: -80px; 
                  }
                  #helpBtn1Div{
                  width: 50%;
                  /*content: '\A';*/
                  /*white-space: pre; */
                  margin-top: 0px;
                  }
                  #helpBtn2Div{
                  width: 50%;
                  /*content: '\A';*/
                  /*white-space: pre; */
                  margin-top: 0px;
                  }
                  #helpBtn3Div{
                  width: 50%;
                  /*content: '\A';*/
                  /*white-space: pre; */
                  margin-top: 0px;
                  }
                  #helpBtn4Div{
                  width: 50%;
                  /*content: '\A';*/
                  /*white-space: pre; */
                  margin-top: 0px;
                  }
                  #ambienceBtn1Div{
                  width: 33%;
                  }
                  #ambienceBtn2Div{
                  width: 33%;
                  }
                  #ambienceBtn3Div{
                  width: 33%;
                  }
                  #ambienceBtn4Div{
                  width: 33%;
                  content: '\A';
                  white-space: pre; 
                  margin-top: 50px; 
                  }
                  #ambienceBtn5Div{
                  width: 33%;
                  content: '\A';
                  white-space: pre; 
                  margin-top: 50px;     
                  }
                  #ambienceBtn6Div{
                  width: 33%;
                  content: '\A';
                  white-space: pre; 
                  margin-top: 50px;      
                  }
                  #ambienceSlider{
                  margin-top: 30px;
                  }
                  #ambienceBadges{
                  font-size: 22px;
                  background-color:var(--main-time-color);
                  color: black; 
                  }
                  #exploreBtnId{
                  margin-top: 40px;
                  height: 60px;
                  width: 300px;
                  border-radius: 5px;
                  font-size: 26px;
                  font-weight: 700;            
                  }
            /* RANGER                      */
                  input[type="range"]{
                  -webkit-appearance: none;
                  height: 10px;
                  width: 180px;
                  border-radius: 20px;
                  margin: auto;
                  border: 0px dotted transparent;  
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.2);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.2);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.2); 
                  }
                  input[type="range"]::-moz-range-track{
                  -webkit-appearance: none;
                  height: 10px;
                  width: 180px;
                  border-radius: 20px;
                  margin: auto;
                  border: 0px dotted transparent;  
                   -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.2);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.2);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.2); 
                  }
                  input[type="range"]::-webkit-slider-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 50px;
                  height: 50px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  border: 0px dotted transparent;  
                  }
                  input[type="range"]::-moz-range-thumb{
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 50px;
                  height: 50px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  border: 0px dotted transparent;  
                  } 
            /* MAILING LIST                */
                  #mailingListText{
                  margin-top: 20px;
                  margin-bottom: 0px;
                  font-size: 18px;   
                  }
                  #mce-EMAIL{
                  font-size:16px; 
                  padding: 4px 10px;
                  margin-top: 0px;  
                  width: 250px;
                  border-width: 1px;
                  border-radius: 6px;
                  background-color: transparent;
                  border-color: black;
                  }
                  #mc-embedded-subscribe{
                  font-size:16px; 
                  padding: 4px 10px;
                  margin-top: 6px;
                  border-width: 1px;
                  border-radius: 6px;
                  background-color: transparent;
                  border-color: black;
                  } 
      }
/** STYLINGS FOR SCREENS  > 769px         */
      @media (min-width: 1025px) and (max-width: 1369px){
                  #mainDiv{
                  padding-right: 0px;
                  padding-left: 0px;
                  max-width: 4000px; 
                  height: 2500px;  
                  }
                  #controlsContainer{
                  max-width: 1400px;
                  margin-top: 6%;
                  }
                  #visualToggleContainer{
                  margin-top: 20px;      
                  }
                  #visualToggle{
                  font-size: 20px;      
                  }
      @media (max-height: 549px) {
                  #optionsBucket{
                  margin-top: 0.25%;
                  }
                  #enterContainer{
                  margin-top: 140px;
                  } 
                  #controlsContainerTutorial{
                  max-width: 1400px;
                  margin-top: -10px;      
                  }
                  #fxTitleTutorial{
                  font-weight: 700;
                  font-size: 32px;
                  color:white;  
                  margin-top: 30px;  
                  }
                  #aboutPageID{
                  margin-top: 30px;
                  }
                  #welcomeBtnVoice{
                  height: 45px;
                  width: 807px;
                  margin-top: 15px;
                  margin-left: -4px;
                  font-size: 22px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;      
                  }
                  #welcomeBtn{
                  height: 65px;
                  width: 400px;
                  margin-top: 8px;
                  margin-left: 3px;
                  font-size: 34px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  #welcomeBtnAbout{
                  height: 65px;
                  width: 807px;
                  margin-top: 8px;
                  margin-left: -1px;
                  font-size: 34px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  }
      @media (min-height: 550px) and (max-height: 600px) { 
                  #optionsBucket{
                  margin-top: 0.25%;
                  }
                  #enterContainer{
                  margin-top: 160px;
                  }
                  #controlsContainerTutorial{
                  max-width: 1400px;
                  margin-top: -10px;      
                  }
                  #fxTitleTutorial{
                  font-weight: 700;
                  font-size: 32px;
                  color:white;  
                  margin-top: 30px;  
                  }
                  #aboutPageID{
                  margin-top: 30px;
                  }
                  #welcomeBtnVoice{
                  height: 45px;
                  width: 807px;
                  margin-top: 15px;
                  margin-left: -4px;
                  font-size: 22px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;      
                  }
                  #welcomeBtn{
                  height: 70px;
                  width: 400px;
                  margin-top: 8px;
                  margin-left: 3px;
                  font-size: 38px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  #welcomeBtnAbout{
                  height: 70px;
                  width: 807px;
                  margin-top: 8px;
                  margin-left: -1px;
                  font-size: 38px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  }
      @media (min-height: 601px) and (max-height: 649px) {
                  #optionsBucket{
                  margin-top: 0%;
                  }
                  #enterContainer{
                  margin-top: 180px;
                  }
                  #controlsContainerTutorial{
                  max-width: 1400px;
                  margin-top: -10px;      
                  }
                  #fxTitleTutorial{
                  font-weight: 700;
                  font-size: 32px;
                  color:white;  
                  margin-top: 30px;  
                  }
                  #aboutPageID{
                  margin-top: 30px;
                  }
                  #welcomeBtnVoice{
                  height: 50px;
                  width: 908px;
                  margin-top: 15px;
                  margin-left: -4px;
                  font-size: 26px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;      
                  }
                  #welcomeBtn{
                  height: 80px;
                  width: 450px;
                  margin-top: 8px;
                  margin-left: 3px;
                  font-size: 42px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  #welcomeBtnAbout{
                  height: 80px;
                  width: 907px;
                  margin-top: 8px;
                  margin-left: 0px;
                  font-size: 42px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  }
      @media (min-height: 650px) and (max-height: 700px) {
                  #optionsBucket{
                  margin-top: 0.5%;
                  }
                  #enterContainer{
                  margin-top: 200px;
                  }
                  #controlsContainerTutorial{
                  max-width: 1400px;
                  margin-top: -10px;      
                  }
                  #fxTitleTutorial{
                  font-weight: 700;
                  font-size: 32px;
                  color:white;  
                  margin-top: 30px;  
                  }
                  #aboutPageID{
                  margin-top: 30px;
                  }
                  #welcomeBtnVoice{
                  height: 50px;
                  width: 908px;
                  margin-top: 15px;
                  margin-left: -4px;
                  font-size: 24px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;      
                  }
                  #welcomeBtn{
                  height: 75px;
                  width: 450px;
                  margin-top: 8px;
                  margin-left: 4px;
                  font-size: 38px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  #welcomeBtnAbout{
                  height: 75px;
                  width: 908px;
                  margin-top: 8px;
                  margin-left: 0px;
                  font-size: 38px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  }
      @media (min-height: 701px) and (max-height: 749px) {
                  #optionsBucket{
                  margin-top: 0.75%;
                  }
                  #enterContainer{
                  margin-top: 220px;
                  }
                  #controlsContainerTutorial{
                  max-width: 1400px;
                  margin-top: -10px;      
                  }
                  #fxTitleTutorial{
                  font-weight: 700;
                  font-size: 32px;
                  color:white;  
                  margin-top: 30px;  
                  }
                  #aboutPageID{
                  margin-top: 50px;
                  }
                  #welcomeBtnVoice{
                  height: 50px;
                  width: 908px;
                  margin-top: 15px;
                  margin-left: -4px;
                  font-size: 26px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;      
                  }
                  #welcomeBtn{
                  height: 90px;
                  width: 450px;
                  margin-top: 8px;
                  margin-left: 4px;
                  font-size: 42px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  #welcomeBtnAbout{
                  height: 90px;
                  width: 908px;
                  margin-top: 8px;
                  margin-left: 0px;
                  font-size: 42px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  }
      @media (min-height: 750px) and (max-height: 800px) {
                  #optionsBucket{
                  margin-top: 1.75%;
                  }
                  #enterContainer{
                  margin-top: 240px;
                  }
                  #controlsContainerTutorial{
                  max-width: 1400px;
                  margin-top: -10px;      
                  }
                  #fxTitleTutorial{
                  margin-top: 20px;  
                  }
                  #aboutPageID{
                  margin-top: 70px;
                  }
                  #welcomeBtnVoice{
                  height: 50px;
                  width: 908px;
                  margin-top: 15px;
                  margin-left: -4px;
                  font-size: 26px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;      
                  }
                  #welcomeBtn{
                  height: 90px;
                  width: 450px;
                  margin-top: 8px;
                  margin-left: 4px;
                  font-size: 42px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  #welcomeBtnAbout{
                  height: 90px;
                  width: 908px;
                  margin-top: 8px;
                  margin-left: 0px;
                  font-size: 42px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  }
      @media (min-height: 801px) and (max-height: 849px) {
                  #optionsBucket{
                  margin-top: 3%;
                  }
                  #enterContainer{
                  margin-top: 240px;
                  }
                  #controlsContainerTutorial{
                  max-width: 1400px;
                  margin-top: -10px;      
                  }
                  #fxTitleTutorial{
                  font-weight: 700;
                  font-size: 32px;
                  color:white;  
                  margin-top: 30px;  
                  }
                  #aboutPageID{
                  margin-top: 90px;
                  }
                  #welcomeBtnVoice{
                  height: 50px;
                  width: 908px;
                  margin-top: 15px;
                  margin-left: -4px;
                  font-size: 26px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;      
                  }
                  #welcomeBtn{
                  height: 90px;
                  width: 450px;
                  margin-top: 8px;
                  margin-left: 4px;
                  font-size: 42px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  #welcomeBtnAbout{
                  height: 90px;
                  width: 908px;
                  margin-top: 8px;
                  margin-left: 0px;
                  font-size: 42px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  }
      @media (min-height: 850px) and (max-height: 900px) { 
                  #optionsBucket{
                  margin-top: 1.5%;
                  }
                  #enterContainer{
                  margin-top: 300px;
                  }
                  #controlsContainerTutorial{
                  max-width: 1400px;
                  margin-top: -50px;      
                  }
                  #fxTitleTutorial{
                  font-weight: 700;
                  font-size: 32px;
                  color:white;  
                  margin-top: 70px;  
                  }
                  #aboutPageID{
                  margin-top: 120px;
                  }
                  #welcomeBtnVoice{
                  height: 50px;
                  width: 1014px;
                  margin-top: 15px;
                  margin-left: 8px;
                  font-size: 26px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;      
                  }
                  #welcomeBtn{
                  height: 100px;
                  width: 500px;
                  margin-top: 15px;
                  margin-left: 10px;
                  font-size: 45px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  #welcomeBtnAbout{
                  height: 100px;
                  width: 1014px;
                  margin-top: 15px;
                  margin-left: 8px;
                  font-size: 45px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  }
      @media (min-height: 901px) and (max-height: 949px) { 
                  #optionsBucket{
                  margin-top: 2%;
                  }
                  #enterContainer{
                  margin-top: 300px;
                  }
                  #controlsContainerTutorial{
                  max-width: 1400px;
                  margin-top: -80px;      
                  }
                  #fxTitleTutorial{
                  margin-top: 30px;  
                  }
                  #aboutPageID{
                  margin-top: 140px;
                  }
                  #welcomeBtnVoice{
                  height: 50px;
                  width: 1014px;
                  margin-top: 15px;
                  margin-left: 8px;
                  font-size: 26px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;      
                  }
                  #welcomeBtn{
                  height: 100px;
                  width: 500px;
                  margin-top: 15px;
                  margin-left: 10px;
                  font-size: 45px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  #welcomeBtnAbout{
                  height: 100px;
                  width: 1014px;
                  margin-top: 15px;
                  margin-left: 8px;
                  font-size: 45px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  }
      @media (min-height: 950px) and (max-height: 1000px) { 
                  #optionsBucket{
                  margin-top: 4%;
                  }
                  #enterContainer{
                  margin-top: 300px;
                  }
                  #controlsContainerTutorial{
                  max-width: 1400px;
                  margin-top: -100px;      
                  }
                  #fxTitleTutorial{
                  font-weight: 700;
                  font-size: 32px;
                  color:white;  
                  margin-top: 120px;  
                  }
                  #aboutPageID{
                  margin-top: 200px;
                  }
                  #welcomeBtnVoice{
                  height: 50px;
                  width: 1014px;
                  margin-top: 15px;
                  margin-left: 8px;
                  font-size: 26px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;      
                  }
                  #welcomeBtn{
                  height: 100px;
                  width: 500px;
                  margin-top: 15px;
                  margin-left: 10px;
                  font-size: 45px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  #welcomeBtnAbout{
                  height: 100px;
                  width: 1014px;
                  margin-top: 15px;
                  margin-left: 8px;
                  font-size: 45px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  }
      @media (min-height: 1001px) and (max-height: 1100px) {
                  #optionsBucket{
                  margin-top: 5%;
                  }
                  #enterContainer{
                  margin-top: 320px;
                  }
                  #controlsContainerTutorial{
                  max-width: 1400px;
                  margin-top: -120px;      
                  }
                  #fxTitleTutorial{
                  font-weight: 700;
                  font-size: 32px;
                  color:white;  
                  margin-top: 160px;  
                  }
                  #aboutPageID{
                  margin-top: 15%;
                  }
                  #welcomeBtnVoice{
                  height: 50px;
                  width: 1014px;
                  margin-top: 15px;
                  margin-left: 8px;
                  font-size: 26px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;      
                  }
                  #welcomeBtn{
                  height: 100px;
                  width: 500px;
                  margin-top: 15px;
                  margin-left: 10px;
                  font-size: 45px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  #welcomeBtnAbout{
                  height: 100px;
                  width: 1014px;
                  margin-top: 15px;
                  margin-left: 8px;
                  font-size: 45px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  }
      @media (min-height: 1101px) {
                  #optionsBucket{
                  margin-top: 5%;
                  }
                  #enterContainer{
                  margin-top: 320px;
                  }
                  #controlsContainerTutorial{
                  max-width: 1400px;
                  margin-top: -120px;      
                  }
                  #fxTitleTutorial{
                  font-weight: 700;
                  font-size: 32px;
                  color:white;  
                  margin-top: 160px;  
                  }
                  #aboutPageID{
                  margin-top: 15%;
                  }
                  #welcomeBtnVoice{
                  height: 50px;
                  width: 1014px;
                  margin-top: 15px;
                  margin-left: 8px;
                  font-size: 26px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;      
                  }
                  #welcomeBtn{
                  height: 100px;
                  width: 500px;
                  margin-top: 15px;
                  margin-left: 10px;
                  font-size: 45px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  #welcomeBtnAbout{
                  height: 100px;
                  width: 1014px;
                  margin-top: 15px;
                  margin-left: 8px;
                  font-size: 45px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }     
                  }
            /* WELCOME                     */
                  #welcomeInfoText{
                  margin-top: 50px;
                  font-size: 30px;
                  color: black;
                  font-weight: 700;
                  }
                  #welcomeMobileText{
                  color: black;
                  font-size: 18px;
                  font-weight: 700;
                  }
                  #bell{
                  color: var(--main-v1-color);      
                  }
                  #enterFuncBtn{
                  font-size: 48px;
                  height: 350px;
                  width: 350px;
                  border-radius: 300px;
                  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);
                  }   
            /* ABOUT                       */
                  #helpContainer{
                  max-width: 350px;
                  margin-top: 30px;
                  }
                  #helpContainerTutorial{
                  max-width: 350px;
                  margin-top: 30px;
                  }
                  #aboutBtnID{
                  height: 45px;
                  width: 125px;
                  border-radius: 5px;
                  font-size: 22px;
                  font-weight: 400;
                  }
                  #localStorageBtnID{
                  height: 45px;
                  width: 125px;
                  border-radius: 5px;
                  font-size: 22px;
                  font-weight: 400;      
                  }
                  #aboutBtnID2{
                  margin-top: 20px;
                  padding: 2px 5px;
                  font-weight: 300;
                  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.4);
                  }
                  #aboutPageID{
                  
                  }
                  #aboutTxt{
                  max-width: 1050px;
                  margin: auto;
                  font-size: 22px;
                  text-align: left;
                  color: white;
                  text-shadow: 0px 0.5px 0.5px rgba(0, 0, 0, 0.2);
                  }
                  #shoutOut{
                  font-size: 20px;      
                  }
                  #disclaimerTxt{
                  margin-top: 30px;
                  font-size: 16px;
                  text-shadow: 0px 0.5px 0.5px rgba(0, 0, 0, 0.1);
                  }
                  #aboutSectionVO{
                  margin-top: 20px;
                  margin-bottom: 26px;  
                  width: 260px;
                  border-radius: 4px;
                  font-size: 22px;
                  font-weight: 400;    
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.4); 
                  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.4);      
                  }
            /* MISSON CONTROL              */
                  #fxTitle{
                  font-weight: 300;
                  font-size: 46px;
                  color:white;  
                  margin-top: 40px;
                  margin-bottom: 20px; 
                  text-shadow: 0px 1px 5px rgba(0, 0, 0, 0.4);    
                  }
                  #soundscapeTitleBreak{
                  white-space: pre; 
                  content: '\A';       
                  }
                  #fxTitle2{
                  font-weight: 300;
                  font-size: 38px;
                  color:white;  
                  margin-top: 300px;
                  margin-bottom: 10px; 
                  text-shadow: 0px 1px 5px rgba(0, 0, 0, 0.4);    
                  }
                  #fxTutorialTitle{
                  font-weight: 300;
                  font-size: 40px;
                  color:white;  
                  margin-top: 0px;
                  margin-bottom: 0px; 
                  text-shadow: 0px 1px 5px rgba(0, 0, 0, 0.4);    
                  }
                  #fxTutorialTitle2{
                  font-weight: 300;
                  font-size: 38px;
                  color:white;  
                  margin-top: 140px;
                  margin-bottom: 20px; 
                  text-shadow: 0px 1px 5px rgba(0, 0, 0, 0.4);    
                  }
                  #fxTutorialTitle3{
                  font-weight: 300;
                  font-size: 30px;
                  color:white;  
                  margin-top: 280px;  
                  margin-bottom: 20px;
                  text-shadow: 0px 1px 5px rgba(0, 0, 0, 0.4);  
                  }
                  #masterControlDiv{
                  max-width: 1000px;
                  margin: auto;
                  margin-top: 0px;
                  margin-bottom: 0px;
                  }
                  #masterControlBadges{
                  border-radius: 4px;
                  padding: 8px 4px;
                  font-size: 24px;
                  font-weight: 400;
                  width: 300px;
                  border: 2px solid transparent;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.4); 
                  text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.2);
                  }
                  #masterControlBadgesSFX{
                  border-radius: 4px;
                  padding: 8px 4px;
                  font-size: 24px;
                  font-weight: 400;
                  width: 300px;
                  margin-top: 0px;     
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.4); 
                  text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.2);
                  }
                  #voice1SliderDiv{
                  margin-top: 10px;
                  width: 33%;
                  }
                  #voice2SliderDiv{
                  margin-top: 10px;
                  width: 33%;
                  }
                  #voice3SliderDiv{
                  margin-top: 10px;
                  width: 33%;
                  }
                  #voice4SliderDiv{
                  width: 33%;
                  /*white-space: pre; 
                  content: '\A'; */
                  margin-top: 30px;
                  }
                  #voice5SliderDiv{
                  width: 33%;
                 /* white-space: pre; 
                  content: '\A'; */
                  margin-top: 30px;
                  }
                  #voice6SliderDiv{
                  width: 33%;
                  white-space: pre; 
                  content: '\A'; 
                  margin-top: 30px;
                  }
                  #sliders1{
                  margin-top: 30px;
                  }
                  #sliders2{
                  margin-top: 30px;
                  }
                  #sliders3{
                  margin-top: 30px;
                  }
                  #sliders4{
                  margin-top: 30px;
                  }
                  #sliders5{
                  margin-top: 30px;      
                  }
                  #sliders6{
                  margin-top: 30px;
                  }            
            /* AMBIANCE BUTTONS            */
                  #ambienceBtnLocation{
                  max-width: 1000px;
                  margin: auto;
                  margin-top: 0px;
                  margin-bottom: 0px;
                  }
                  #ambienceBtns{
                  width: 300px;
                  border-radius: 4px;
                  font-size: 26px;
                  font-weight: 400;    
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.4); 
                  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.4);  
                  }
                  #tutorialContainer{
                  max-width: 1000px;
                  margin: auto;
                  margin-top: 10px;
                  margin-bottom: -60px;      
                  }
                  #helpBtn1Div{
                  width: 50%;
                  content: '\A'; 
                  white-space: pre;  
                  }
                  #helpBtn2Div{
                  width: 50%;
                  content: '\A'; 
                  white-space: pre;  
                  }
                  #helpBtn3Div{
                  width: 50%;
                  content: '\A'; 
                  white-space: pre;
                  margin-top: 20px;
                  }
                  #helpBtn4Div{
                  width: 50%;
                  content: '\A'; 
                  white-space: pre;
                  margin-top: 20px;
                  }
                  #ambienceBtn1Div{
                  width: 33%;
                  content: '\A';    
                  }
                  #ambienceBtn2Div{
                  width: 33%;
                  content: '\A';
                  }
                  #ambienceBtn3Div{
                  width: 33%;
                  content: '\A';
                  }
                  #ambienceBtn4Div{
                  width: 33%;
                  content: '\A';
                  white-space: pre; 
                  margin-top: 40px;
                  }
                  #ambienceBtn5Div{
                  width: 33%;
                  content: '\A';
                  white-space: pre; 
                  margin-top: 40px;
                  }
                  #ambienceBtn6Div{
                  width: 33%;
                  content: '\A';
                  white-space: pre; 
                  margin-top: 40px;
                  }
                  #ambienceSlider{
                  margin-top: 30px;
                  }
                  #ambienceBadges{
                  font-size: 22px;
                  background-color:var(--main-time-color);
                  color: black; 
                  }
                  #exploreBtnId{
                  margin-top: 80px;
                  height: 45px;
                  width: 300px;
                  border-radius: 5px;
                  font-size: 22px;
                  font-weight: 400;            
                  }
            /* SPEECH STUDIO               */
                  #speechList{
                  margin-top: 80px;
                  height: 40px;
                  width: 300px;
                  padding: 0px 0px;
                  border-radius: 5px;
                  font-size: 22px;
                  font-weight: 400;        
                  }
                  #voiceListAnchor{
                  }
                  #voiceCommandListID{
                  max-width: 750px;
                  margin: auto;
                  border-radius: 10px;
                  margin-top: 20px;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.4); 
                  }
                  #voiceControlListTitle{
                  padding-top: 5px;
                  font-size: 30px;    
                  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.4);  
                  }
                  #voiceControlListTxt{
                  font-size: 20px;       
                  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.4); 
                  padding-bottom: 10px;
                  }
                  #speechEngage{
                  margin-top: 15px;
                  margin-left: 60px;
                  font-size: 60px;
                  }
                  #speechEngageActivated{
                  margin-top: 15px;
                  margin-left: 68px;
                  font-size: 60px;      
                  }
                  #VUIformInputDivID{
                  max-width: 650px; 
                  margin: center; 
                  /*display: inline;  */
                  /*margin-left: 0px;*/
                  margin-bottom: -75px;
                  }
                  #inlineFormInputGroupUsername2{
                  margin: auto;
                  margin-top: 20px;
                  margin-left: 80px;
                  text-align: center;
                  font-size: 25px;
                  width: 500px;
                  height: 50px;
                  border-radius: 20px;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.3);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.3);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.3); 
                  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.2); 
                  }
            /* RANGER                      */
                  input[type="range"]{
                  -webkit-appearance: none;
                  height: 10px;
                  width: 180px;
                  border-radius: 20px;
                  margin: auto;
                  border: 0px dotted transparent; 
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.2);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.2);
                  box-shadow: 0px 4px 10px 1px rgba(0, 0, 0, 0.3); 
                  }
                  input[type="range"]::-moz-range-track{
                  -webkit-appearance: none;
                  height: 10px;
                  width: 180px;
                  border-radius: 20px;
                  margin: auto;
                  border: 0px dotted transparent;  
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.2);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.2);
                  box-shadow: 0px 4px 10px 1px rgba(0, 0, 0, 0.3); 
                  }
                  input[type="range"]::-webkit-slider-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  border: 0px dotted transparent;  
                  }
                  input[type="range"]::-moz-range-thumb{
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  border: 0px dotted transparent;  
                  }                  
            /* MAILING LIST                */
                  #mailingListText{
                  margin: auto;
                  margin-top: 30px;
                  margin-bottom: 0px;
                  font-size: 20px;  
                  }
                  #mc_embed_signup{
                  background:#fff; 
                  font-size:16px; 
                  width:100%;
                  border-color: black;
                  background-color: transparent;
                  text-shadow: 0px 0.5px 0.5px rgba(0, 0, 0, 0.2);
                  }
                  #mce-EMAIL{
                  font-size:18px; 
                  padding: 4px 10px;
                  margin-top: 0px;  
                  width: 250px;
                  border-width: 1px;
                  border-radius: 6px;
                  background-color: transparent;
                  border-color: black;
                  text-shadow: 0px 0.5px 0.5px rgba(0, 0, 0, 0.2);
                  }
                  #mc-embedded-subscribe{
                  font-size:18px; 
                  padding: 4px 10px;
                  margin-top: 4px;
                  border-width: 1px;
                  border-radius: 6px;
                  background-color: transparent;
                  border-color: black;
                  text-shadow: 0px 0.5px 0.5px rgba(0, 0, 0, 0.2);
                  }    
    }
/** STYLINGS FOR DESKTOP SCREENS > 1600px  */
      @media (min-width: 1370px) {
                  #mainDiv{
                  padding-right: 0px;
                  padding-left: 0px;
                  max-width: 4000px;  
                  height: 2200px; 
                  }
                  #lineBreak{
                  white-space: pre;
                  content: "/A";
                  }
                  #visualToggleContainer{
                  margin-top: 20px;      
                  }
                  #visualToggle{
                  font-size: 20px;      
                  }
      @media (max-height: 549px) {
                  #optionsBucket{
                  margin-top: 0.25%;
                  }
                  #enterContainer{
                  margin-top: 80px;
                  } 
                  #controlsContainer{
                  max-width: 1400px;
                  margin-top: 70px;
                  }
                  #controlsContainerTutorial{
                  max-width: 1400px;
                  margin-top: -10px;      
                  }
                  #fxTitleTutorial{
                  margin-top: 20px;
                  margin-bottom: 40px;   
                  }
                  #aboutPageID{
                  margin-top: 10px;
                  }
                  #welcomeBtnVoice{
                  height: 45px;
                  width: 807px;
                  margin-top: 15px;
                  margin-left: -2px;
                  font-size: 22px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;      
                  }
                  #welcomeBtn{
                  height: 65px;
                  width: 400px;
                  margin-top: 8px;
                  margin-left: 3px;
                  font-size: 34px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  #welcomeBtnAbout{
                  height: 65px;
                  width: 807px;
                  margin-top: 8px;
                  margin-left: -1px;
                  font-size: 34px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  }
      @media (min-height: 550px) and (max-height: 600px) { 
                  #optionsBucket{
                  margin-top: 0.25%;
                  }
                  #enterContainer{
                  margin-top: 120px;
                  }
                  #controlsContainer{
                  max-width: 1400px;
                  margin-top: 80px;
                  }
                  #controlsContainerTutorial{
                  max-width: 1400px;
                  margin-top: -10px;      
                  }
                  #fxTitleTutorial{
                  margin-top: 20px;
                  margin-bottom: 40px;   
                  }
                  #aboutPageID{
                  margin-top: 10px;
                  }
                  #welcomeBtnVoice{
                  height: 45px;
                  width: 807px;
                  margin-top: 15px;
                  margin-left: -2px;
                  font-size: 22px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;      
                  }
                  #welcomeBtn{
                  height: 70px;
                  width: 400px;
                  margin-top: 8px;
                  margin-left: 3px;
                  font-size: 38px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  #welcomeBtnAbout{
                  height: 70px;
                  width: 807px;
                  margin-top: 8px;
                  margin-left: -1px;
                  font-size: 38px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  }
      @media (min-height: 601px) and (max-height: 649px) {
                  #optionsBucket{
                  margin-top: 0%;
                  }
                  #enterContainer{
                  margin-top: 140px;
                  }
                  #controlsContainer{
                  max-width: 1400px;
                  margin-top: 90px;
                  margin-bottom: 0px;
                  }
                  #controlsContainerTutorial{
                  max-width: 1400px;
                  margin-top: -30px;      
                  }
                  #fxTitleTutorial{
                  margin-top: 20px;
                  margin-bottom: 60px;   
                  }
                  #aboutPageID{
                  margin-top: 10px;
                  }
                  #welcomeBtnVoice{
                  height: 45px;
                  width: 907px;
                  margin-top: 15px;
                  margin-left: -4px;
                  font-size: 22px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;      
                  }
                  #welcomeBtn{
                  height: 80px;
                  width: 450px;
                  margin-top: 8px;
                  margin-left: 3px;
                  font-size: 42px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  #welcomeBtnAbout{
                  height: 80px;
                  width: 907px;
                  margin-top: 8px;
                  margin-left: 0px;
                  font-size: 42px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  }
      @media (min-height: 650px) and (max-height: 700px) {
                  #optionsBucket{
                  margin-top: 0%;
                  }
                  #enterContainer{
                  margin-top: 160px;
                  }
                  #controlsContainer{
                  max-width: 1400px;
                  margin-top: 100px;
                  }
                  #controlsContainerTutorial{
                  max-width: 1400px;
                  margin-top: -50px;      
                  }
                  #fxTitleTutorial{
                  margin-top: 20px;
                  margin-bottom: 80px;   
                  }
                  #aboutPageID{
                  margin-top:10px;
                  }
                  #welcomeBtnVoice{
                  height: 50px;
                  width: 908px;
                  margin-top: 15px;
                  margin-left: -4px;
                  font-size: 26px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;      
                  }
                  #welcomeBtn{
                  height: 90px;
                  width: 450px;
                  margin-top: 8px;
                  margin-left: 4px;
                  font-size: 42px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  #welcomeBtnAbout{
                  height: 90px;
                  width: 908px;
                  margin-top: 8px;
                  margin-left: 0px;
                  font-size: 42px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  }
      @media (min-height: 701px) and (max-height: 749px) {
                  #optionsBucket{
                  margin-top: 0.75%;
                  }
                  #enterContainer{
                  margin-top: 200px;
                  }
                  #controlsContainer{
                  max-width: 1400px;
                  margin-top: 120px;
                  }
                  #controlsContainerTutorial{
                  max-width: 1400px;
                  margin-top: -70px;      
                  }
                  #fxTitleTutorial{
                  margin-top: 20px;
                  margin-bottom: 100px;   
                  }
                  #aboutPageID{
                  margin-top: 40px;
                  }
                  #welcomeBtnVoice{
                  height: 50px;
                  width: 908px;
                  margin-top: 15px;
                  margin-left: -4px;
                  font-size: 26px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;      
                  }
                  #welcomeBtn{
                  height: 90px;
                  width: 450px;
                  margin-top: 8px;
                  margin-left: 4px;
                  font-size: 42px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  #welcomeBtnAbout{
                  height: 90px;
                  width: 908px;
                  margin-top: 8px;
                  margin-left: 0px;
                  font-size: 42px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  }
      @media (min-height: 750px) and (max-height: 800px) {
                  #optionsBucket{
                  margin-top: 0.5%;
                  }
                  #enterContainer{
                  margin-top: 220px;
                  }
                  #controlsContainer{
                  max-width: 1500px;
                  margin-top: 140px;
                  /*margin-right: 14px;*/
                  }
                  #controlsContainerTutorial{
                  max-width: 1400px;
                  margin-top: -80px;      
                  }
                  #fxTitleTutorial{
                  margin-top: 20px;
                  margin-bottom: 120px;   
                  }
                  #aboutPageID{
                  margin-top: 8%;
                  }
                  #welcomeBtnVoice{
                  height: 50px;
                  width: 908px;
                  margin-top: 15px;
                  margin-left: -4px;
                  font-size: 26px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;      
                  }
                  #welcomeBtn{
                  height: 90px;
                  width: 450px;
                  margin-top: 8px;
                  margin-left: 4px;
                  font-size: 42px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  #welcomeBtnAbout{
                  height: 90px;
                  width: 908px;
                  margin-top: 8px;
                  margin-left: 0px;
                  font-size: 42px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  }
      @media (min-height: 801px) and (max-height: 849px) {
                  #optionsBucket{
                  margin-top: 3%;
                  }
                  #enterContainer{
                  margin-top: 240px;
                  }
                  #controlsContainer{
                  max-width: 1400px;
                  margin-top: 160px;
                  /*margin-left: 12px;*/
                  }
                  #controlsContainerTutorial{
                  max-width: 1400px;
                  margin-top: -80px;      
                  }
                  #fxTitleTutorial{
                  margin-top: 20px;
                  margin-bottom: 130px;   
                  }
                  #aboutPageID{
                  margin-top: 80px;
                  }
                  #welcomeBtnVoice{
                  height: 50px;
                  width: 908px;
                  margin-top: 15px;
                  margin-left: -4px;
                  font-size: 26px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;      
                  }
                  #welcomeBtn{
                  height: 90px;
                  width: 450px;
                  margin-top: 8px;
                  margin-left: 4px;
                  font-size: 42px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  #welcomeBtnAbout{
                  height: 90px;
                  width: 908px;
                  margin-top: 8px;
                  margin-left: 0px;
                  font-size: 42px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  }
      @media (min-height: 850px) and (max-height: 900px) { 
                  #optionsBucket{
                  margin-top: 1%;
                  }
                  #enterContainer{
                  margin-top: 260px;
                  }
                  #controlsContainer{
                  max-width: 1400px;
                  margin-top: 190px;
                  }
                  #controlsContainerTutorial{
                  max-width: 1400px;
                  margin-top: -100px;      
                  }
                  #fxTitleTutorial{
                  margin-top: 20px;
                  margin-bottom: 130px;   
                  }
                  #aboutPageID{
                  margin-top: 120px;
                  }
                  #welcomeBtnVoice{
                  height: 50px;
                  width: 1014px;
                  margin-top: 15px;
                  margin-left: 8px;
                  font-size: 26px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;      
                  }
                  #welcomeBtn{
                  height: 100px;
                  width: 500px;
                  margin-top: 15px;
                  margin-left: 10px;
                  font-size: 45px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  #welcomeBtnAbout{
                  height: 100px;
                  width: 1014px;
                  margin-top: 15px;
                  margin-left: 8px;
                  font-size: 45px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  }
      @media (min-height: 901px) and (max-height: 949px) { 
                  #optionsBucket{
                  margin-top: 1%;
                  }
                  #enterContainer{
                  margin-top: 280px;
                  }
                  #controlsContainer{
                  max-width: 1600px;
                  margin-top: 200px;
                  }
                  #controlsContainerTutorial{
                  max-width: 1400px;
                  margin-top: 0px;      
                  }
                  #fxTitleTutorial{
                  margin-top: 40px;
                  margin-bottom: 50px;  
                  }
                  #aboutPageID{
                  margin-top: 10%;
                  }
                  #welcomeBtnVoice{
                  height: 50px;
                  width: 1014px;
                  margin-top: 15px;
                  margin-left: 8px;
                  font-size: 26px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;      
                  }
                  #welcomeBtn{
                  height: 100px;
                  width: 500px;
                  margin-top: 15px;
                  margin-left: 10px;
                  font-size: 45px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  #welcomeBtnAbout{
                  height: 100px;
                  width: 1014px;
                  margin-top: 15px;
                  margin-left: 8px;
                  font-size: 45px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  }
      @media (min-height: 950px) and (max-height: 1000px) { 
                  #optionsBucket{
                  margin-top: 4%;
                  }
                  #enterContainer{
                  margin-top: 300px;
                  }
                  #controlsContainer{
                  max-width: 1400px;
                  margin-top: 250px;
                  }
                  #controlsContainerTutorial{
                  max-width: 1400px;
                  margin-top: 0px;      
                  }
                  #fxTitleTutorial{
                  margin-top: 80px;
                  margin-bottom: 50px; 
                  }
                  #helpContainer{
                  margin-top: 0px;      
                  }
                  #aboutPageID{
                  margin-top: 12%;
                  }
                  #welcomeBtnVoice{
                  height: 50px;
                  width: 1014px;
                  margin-top: 15px;
                  margin-left: 8px;
                  font-size: 26px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;      
                  }
                  #welcomeBtn{
                  height: 100px;
                  width: 500px;
                  margin-top: 15px;
                  margin-left: 10px;
                  font-size: 45px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  #welcomeBtnAbout{
                  height: 100px;
                  width: 1014px;
                  margin-top: 15px;
                  margin-left: 8px;
                  font-size: 45px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  }
      @media (min-height: 1001px) and (max-height: 1100px) {
                  #optionsBucket{
                  margin-top: 4%;
                  }
                  #enterContainer{
                  margin-top: 320px;
                  }
                  #controlsContainer{
                  max-width: 1400px;
                  margin-top: 260px;
                  }
                  #controlsContainerTutorial{
                  max-width: 1400px;
                  margin-top: 100px;      
                  }
                  #fxTitleTutorial{
                  margin-top: 140px;
                  margin-bottom: 50px;  
                  }
                  #helpContainer{
                  margin-top: 0px;      
                  }
                  #aboutPageID{
                  margin-top: 13%;
                  }
                  #welcomeBtnVoice{
                  height: 50px;
                  width: 1014px;
                  margin-top: 15px;
                  margin-left: 8px;
                  font-size: 26px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;      
                  }
                  #welcomeBtn{
                  height: 100px;
                  width: 500px;
                  margin-top: 15px;
                  margin-left: 10px;
                  font-size: 45px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  #welcomeBtnAbout{
                  height: 100px;
                  width: 1014px;
                  margin-top: 15px;
                  margin-left: 8px;
                  font-size: 45px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  }
      @media (min-height: 1101px) {
                  #optionsBucket{
                  margin-top: 6%;
                  }
                  #enterContainer{
                  margin-top: 340px;
                  }
                  #controlsContainer{
                  max-width: 1400px;
                  margin-top: 270px;
                  }
                  #controlsContainerTutorial{
                  max-width: 1400px;
                  margin-top: 0px;      
                  }
                  #fxTitleTutorial{
                  margin-top: 20px;
                  margin-bottom: 50px;  
                  }
                  #helpContainer{
                  margin-top: 0px;      
                  }
                  #aboutPageID{
                  margin-top: 13%;
                  } 
                  #welcomeBtnVoice{
                  height: 50px;
                  width: 1014px;
                  margin-top: 15px;
                  margin-left: 8px;
                  font-size: 26px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;      
                  }
                  #welcomeBtn{
                  height: 100px;
                  width: 500px;
                  margin-top: 15px;
                  margin-left: 10px;
                  font-size: 45px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }
                  #welcomeBtnAbout{
                  height: 100px;
                  width: 1014px;
                  margin-top: 15px;
                  margin-left: 8px;
                  font-size: 45px;
                  border-color: black;
                  border-width: 2px;
                  border-radius: 4px;
                  background-color: transparent;
                  }     
                  }
            /* WELCOME                     */
                  #welcomeInfoText{
                  margin-top: 50px;
                  font-size: 30px;
                  color: black;
                  font-weight: 700;
                  }
                  #welcomeMobileText{
                  color: black;
                  font-size: 18px;
                  font-weight: 700;
                  }
                  #bell{
                  color: var(--main-v1-color);      
                  }
                  #enterFuncBtn{
                  font-size: 45px;
                  height: 350px;
                  width: 350px;
                  border-radius: 300px;
                  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);
                  }   
            /* ABOUT                       */
                  #helpContainer{
                  max-width: 350px;
                  margin-top: 30px;
                  }
                  #helpContainerTutorial{
                  max-width: 360px;
                  margin-top: 30px;
                  }
                  #aboutBtnID{
                  height: 45px;
                  width: 125px;
                  border-radius: 5px;
                  font-size: 22px;
                  font-weight: 400;
                  padding: 4px 4px;
                  }
                  #localStorageBtnID{
                  height: 45px;
                  width: 125px;
                  border-radius: 5px;
                  font-size: 22px;
                  font-weight: 400;
                  padding: 4px 4px;      
                  }
                  #aboutBtnID2{
                  margin-top: 20px;
                  padding: 2px 5px;
                  font-weight: 300;
                  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.4);
                  }
                  #aboutTxt{
                  max-width: 1050px;
                  margin: auto;
                  font-size: 22px;
                  text-align: left;
                  color: white;
                  text-shadow: 0px 0.5px 0.5px rgba(0, 0, 0, 0.2);
                  }
                  #shoutOut{
                  font-size: 20px;      
                  }
                  #disclaimerTxt{
                  margin-top: 30px;
                  font-size: 16px;
                  text-shadow: 0px 0.5px 0.5px rgba(0, 0, 0, 0.1);
                  }
                  #aboutSectionVO{
                  margin-top: 20px;
                  margin-bottom: 28px;  
                  width: 260px;
                  border-radius: 5px;
                  font-size: 22px;
                  font-weight: 400;  
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.4);    
                  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.4);     
                  }
            /* MISSON CONTROL              */
                  @media (max-height: 800px) {
                  #fxTitle{
                  font-weight: 300;
                  font-size: 40px;
                  color:white;  
                  margin-top: 0px;
                  margin-bottom: 20px; 
                  text-shadow: 0px 1px 5px rgba(0, 0, 0, 0.4);    
                  }
                  }
                  @media (min-height: 801px) {
                  #fxTitle{
                  font-weight: 300;
                  font-size: 40px;
                  color:white;  
                  margin-top: 0px;
                  margin-bottom: 20px; 
                  text-shadow: 0px 1px 5px rgba(0, 0, 0, 0.4);    
                  }
                  }
                  #fxTitle2{
                  font-weight: 300;
                  font-size: 38px;
                  color:white;  
                  margin-top: 0px;
                  margin-bottom: 20px; 
                  text-shadow: 0px 1px 5px rgba(0, 0, 0, 0.4);    
                  }
                  #fxTutorialTitle{
                  font-weight: 300;
                  font-size: 44px;
                  color:white;  
                  margin-top: 0px;
                  margin-bottom: 0px; 
                  text-shadow: 0px 1px 5px rgba(0, 0, 0, 0.4);    
                  }
                  #fxTutorialTitle2{
                  font-weight: 300;
                  font-size: 44px;
                  color:white;  
                  margin-top: 0px;
                  margin-bottom: 20px; 
                  text-shadow: 0px 1px 5px rgba(0, 0, 0, 0.4);    
                  }
                  #fxTutorialTitle3{
                  font-weight: 300;
                  font-size: 36px;
                  color:white;  
                  margin-top: 160px;  
                  margin-bottom: 20px;
                  text-shadow: 0px 1px 5px rgba(0, 0, 0, 0.4);  
                  }
                  #fxTitleTutorial{
                  font-weight: 300;
                  font-size: 40px;
                  color:white;  
                  text-shadow: 0px 1px 5px rgba(255, 255, 255, 0.4);    
                  }
                  #masterControlDiv{
                  margin-top: 140px;
                  margin-bottom: 0px;
                  }
                  #masterControlBadges{
                  padding: 8px 8px;
                  font-size: 20px;
                  font-weight: 400;
                  width: 220px;
                  border: 2px solid transparent;
                  border-radius: 5px;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.4); 
                  text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.2);
                  }
                  #masterControlBadgesSFX{
                  padding: 8px 8px;
                  font-size: 20px;
                  font-weight: 400;
                  width: 220px;
                  border-radius: 5px;
                  margin-top: 0px;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.4); 
                  text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.2);
                  }
                  #voice1SliderDiv{
                   
                  }
                  #voice2SliderDiv{

                  }
                  #voice3SliderDiv{
                      
                  }
                  #voice4SliderDiv{
                     
                  }
                  #voice5SliderDiv{
                     
                  }
                  #voice6SliderDiv{
                     
                  }
                  #sliders1{
                  margin-top: 30px;
                  }
                  #sliders2{
                  margin-top: 30px;
                  }
                  #sliders3{
                  margin-top: 30px;
                  }
                  #sliders4{
                  margin-top: 30px;
                  }
                  #sliders5{
                  margin-top: 30px;
                  }
                  #sliders6{
                  margin-top: 30px;
                  }
            /* AMBIANCE BUTTONS & TUTORIAL */
                  #ambienceBtnLocation{
                  margin: auto;
                  margin-top: 0px;
                  margin-bottom: 0px;
                  }
                  #ambienceBtns{
                  width: 220px;
                  border-radius: 5px;
                  font-size: 24px;
                  font-weight: 400;
                  /*text-align: left;   */
                  }
                  #ambienceTxtID{
                  /*margin-left: 10px;         */
                  }
                  #tutorialContainer{
                  font-weight: 400;
                  max-width: 1000px;
                  margin: auto;
                  margin-top: 0px;
                  }
                  #helpBtn1Div{
                  width: 25%;
                  }
                  #helpBtn2Div{
                  width: 25%;
                  }
                  #helpBtn3Div{
                  width: 25%;
                  }
                  #helpBtn4Div{
                  width: 25%;
                  }
                  #ambienceBtn1Div{
                  
                  }
                  #ambienceBtn2Div{
                  
                  }
                  #ambienceBtn3Div{
                  
                  }
                  #ambienceBtn4Div{
                  
                  }
                  #ambienceBtn5Div{
                  
                  }
                  #ambienceBtn6Div{

                  }
                  #ambienceSlider{
                  margin-top: 25px;
                  }
                  #exploreBtnId{
                  margin-top: 80px;
                  height: 45px;
                  width: 300px;
                  border-radius: 5px;
                  font-size: 22px;
                  font-weight: 400;            
                  }
            /* SPEECH STUDIO               */
                  #speechList{
                  margin-top: 80px;
                  height: 45px;
                  width: 300px;
                  border-radius: 5px;
                  font-size: 22px;
                  font-weight: 400;        
                  }
                  #voiceListAnchor{
                  }
                  #voiceCommandListID{
                  max-width: 750px;
                  margin: auto;
                  border-radius: 10px;
                  margin-top: 40px;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.4);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.4); 
                  }
                  #voiceControlListTitle{
                  padding-top: 5px;
                  font-size: 30px;    
                  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.4);  
                  }
                  #voiceControlListTxt{
                  font-size: 20px;       
                  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.4); 
                  padding-bottom: 10px;
                  }
                  #speechEngage{
                  margin-top: 15px;
                  margin-left: 60px;
                  font-size: 60px;
                  }
                  #speechEngageActivated{
                  margin-top: 15px;
                  margin-left: 68px;
                  font-size: 60px;      
                  }
                  #VUIformInputDivID{
                  max-width: 650px; 
                  margin: center; 
                  /*display: inline;  */
                  /*margin-left: 0px;*/
                  margin-bottom: -75px;
                  }
                  #inlineFormInputGroupUsername2{
                  margin: auto;
                  margin-top: 20px;
                  margin-left: 80px;
                  text-align: center;
                  font-size: 25px;
                  width: 500px;
                  height: 50px;
                  border-radius: 20px;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.3);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.3);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.3); 
                  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.2); 
                  }
            /* RANGER                      */
                  input[type="range"]{
                  -webkit-appearance: none;
                  /*overflow: hidden;*/
                  height: 10px;
                  width: 180px;
                  border-radius: 20px;
                  margin: auto;
                  border: 0px dotted transparent;  
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.2);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.2);
                  box-shadow: 0px 4px 10px 1px rgba(0, 0, 0, 0.3); 
                  }
                  input[type="range"]::-moz-range-track{
                  -webkit-appearance: none;
                  height: 10px;
                  width: 180px;
                  border-radius: 20px;
                  margin: auto;
                  border: 0px dotted transparent;  
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.2);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.2);
                  box-shadow: 0px 4px 10px 1px rgba(0, 0, 0, 0.3);
                  }
                  input[type="range"]::-ms-track{
                  background: transparent;
                  border-color: transparent;
                  color: transparent;
                  -webkit-appearance: none;
                  position: relative;
                  z-index:2;
                  min-height: 10px;
                  width: 180px;
                  border-radius: 20px;
                  margin: auto;
                  border: 0px dotted transparent;  
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.2);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.2);
                  box-shadow: 0px 4px 10px 1px rgba(0, 0, 0, 0.3);
                  }


                  input[type="range"]::-webkit-slider-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  border: 0px dotted transparent;  
                  }
                  input[type="range"]::-moz-range-thumb{
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  border: 0px dotted transparent;  
                  }  
                  input[type="range"]::-ms-thumb{
                  border: none;
                  height: 40px;
                  width: 50px;
                  border-radius: 50%;
                  }           
            /* MAILING LIST                */
                  #mailingListText{
                  margin: auto;
                  margin-top: 30px;
                  margin-bottom: 0px;
                  font-size: 20px;  
                  }
                  #mc_embed_signup{
                  background:#fff; 
                  font-size:16px; 
                  width:100%;
                  border-color: black;
                  background-color: transparent;
                  text-shadow: 0px 0.5px 0.5px rgba(0, 0, 0, 0.2);
                  }
                  #mce-EMAIL{
                  font-size:18px; 
                  padding: 4px 10px;
                  margin-top: 0px;  
                  width: 250px;
                  border-width: 1px;
                  border-radius: 6px;
                  background-color: transparent;
                  border-color: black;
                  text-shadow: 0px 0.5px 0.5px rgba(0, 0, 0, 0.2);
                  }
                  #mc-embedded-subscribe{
                  font-size:18px; 
                  padding: 4px 10px;
                  margin-top: 4px;
                  border-width: 1px;
                  border-radius: 6px;
                  background-color: transparent;
                  border-color: black;
                  text-shadow: 0px 0.5px 0.5px rgba(0, 0, 0, 0.2);
                  }    
                  
      }
@media (min-width: 1670px) {
            #controlsContainer{
            max-width: 1600px;
            /*margin-top: 250px;*/
            }
            #controlsContainerTutorial{
            max-width: 1600px;      
            }
            #ambienceBtns{
            width: 240px;
            font-size: 26px;
            font-weight: 400;
            }
            #masterControlBadges{
            width: 240px;
            font-size: 22px;
            font-weight: 400;      
            }
            #masterControlBadgesSFX{
            width: 240px;
            font-size: 22px;
            font-weight: 400;      
            }

}
#welcomeBtn{
color: black;
border-color: black;
}
#welcomeBtnVoice{
color: black;
border-color: black;
}
#welcomeBtnAbout{
color: black;
border-color: black;
}
#aboutTxt{
color: black !important;
}
#mailingListTxt{
color: black !important;
}
/** BOOTSTRAP BUTTON COLORS    */
      /*LOADING*/
      .btn-loading,
      .btn-loading:hover, 
      .btn-loading:focus, 
      .btn-loading:active, 
      .btn-loading.active, 
      .btn-loading:active:focus,
      .btn-loading:active:hover,
      .open>.dropdown-toggle.btn-loading {
      color: black;
      background-color:transparent;
      border-width: 2px;
      border-color: transparent;

      }
      /*INFO*/
      .btn-info,
      .btn-info:hover, 
      .btn-info:focus, 
      .btn-info:active, 
      .btn-info:active, 
      .btn-info:active:focus,
      .btn-info:active:hover,
      .open>.dropdown-toggle.btn-info {
      color: black;
      background-color:#22C0F7;
      border-width: 2px;
      border-color: transparent;
      }

      /*SUCCESS*/
      .btn-success,
      .btn-success:hover, 
      .btn-success:focus, 
      .btn-success:active, 
      .btn-success:active, 
      .btn-success:active:focus,
      .btn-success:active:hover,
      .open>.dropdown-toggle.btn-success {
      color: white;
      background-color: var(--main-start-color);
      border-color: var(--main-start-color);; 
      border-width: 2px;
      }

      /*DANGER*/
      .btn-danger,
      .btn-danger:hover, 
      .btn-danger:focus, 
      .btn-danger:active, 
      .btn-danger:active, 
      .btn-danger:active:focus,
      .btn-danger:active:hover, 
      .open>.dropdown-toggle.btn-danger {
      color: black;
      background-color: var(--main-stop-color);
      border-color: var(--main-stop-color); 
      border-width: 2px;
      }

      /*BLACK AND WHITE*/
      .btn-blackwhite,
      .btn-blackwhite:hover, 
      .btn-blackwhite:focus, 
      .btn-blackwhite:active, 
      .btn-blackwhite.active, 
      .btn-blackwhite:active:focus
      .open>.dropdown-toggle.btn-blackwhite {
      color: white;
      background-color: var(--main-fxBadges-color);
      }   

      /*BLACK AND WHITE NEGATIVE*/
      .btn-blackwhiteneg {
      color: black;
      background-color: transparent;
      }
      .btn-blackwhiteneg,
      .btn-blackwhiteneg:hover, 
      .btn-blackwhiteneg:focus, 
      .btn-blackwhiteneg:active, 
      .btn-blackwhiteneg.active, 
      .btn-blackwhiteneg:active:focus
      .open>.dropdown-toggle.btn-blackwhiteneg {
      color: black;
      background-color: transparent;
      }   

      /*TRANSPARENT*/
      .btn-transparent,
      .btn-transparent:hover, 
      .btn-transparent:focus, 
      .btn-transparent:active, 
      .btn-transparent.active, 
      .btn-transparent:active:focus
      .open>.dropdown-toggle.btn-transparent {
      color: white;
      background-color: transparent;
      border-color: white; 
      border-width: 2px;
      } 
/** STYLINGS FOR TRANSITIONS   */
        .animated.rubberBand {
          -webkit-animation-duration: 1.75s;
             -moz-animation-duration: 1.75s;
              -ms-animation-duration: 1.75s;
               -o-animation-duration: 1.75s;
                  animation-duration: 1.75s;
        }
        .animated.rollOut {
          -webkit-animation-duration: .75s;
             -moz-animation-duration: .75s;
              -ms-animation-duration: .75s;
               -o-animation-duration: .75s;
                  animation-duration: .75s;
        }
        .animated.pulse {
          -webkit-animation-duration: .5s;
             -moz-animation-duration: .5s;
              -ms-animation-duration: .5s;
               -o-animation-duration: .5s;
                  animation-duration: .5s;
        }
        .animated.zoomOutLeft {
          -webkit-animation-duration: 1.5s;
             -moz-animation-duration: 1.5s;
              -ms-animation-duration: 1.5s;
               -o-animation-duration: 1.5s;
                  animation-duration: 1.5s;
        }
        .animated.zoomOutUp {
          -webkit-animation-duration: 1.4s;
             -moz-animation-duration: 1.4s;
              -ms-animation-duration: 1.4s;
               -o-animation-duration: 1.4s;
                  animation-duration: 1.4s;
        }
        .animated.fadeOut {
          -webkit-animation-duration: .6s;
             -moz-animation-duration: .6s;
              -ms-animation-duration: .6s;
               -o-animation-duration: .6s;
                  animation-duration: .6s;
        }
        .animated.fadeIn {
          -webkit-animation-duration: 1.5s;
             -moz-animation-duration: 1.5s;
              -ms-animation-duration: 1.5s;
               -o-animation-duration: 1.5s;
                  animation-duration: 1.5s;
        }
        .animated.hinge {
          -webkit-animation-duration: 1s;
             -moz-animation-duration: 1s;
              -ms-animation-duration: 1s;
               -o-animation-duration: 1s;
                  animation-duration: 1s;
        }
        .animated.zoomIn {
          -webkit-animation-duration: .75s;
             -moz-animation-duration: .75s;
              -ms-animation-duration: .75s;
               -o-animation-duration: .75s;
                  animation-duration: .75s;
        }
        

          .fade-enter {
            opacity: 0;
          }

          .fade-enter-active {
            transition: opacity .5s; 
          }

          .fade-leave {
          }

          .fade-leave-active {
            transition: opacity .5s; 
            opacity: 0;
          }
/** COUNTER SPIN FONT AWESOME  */
    .slow-spin {
      -webkit-animation: spin-counter 6s infinite linear;
      -moz-animation: spin-counter 6s infinite linear;
      -o-animation: spin-counter 6s infinite linear;
      animation: spin-counter 6s infinite linear;
      }
    .fa-counter-spin {
      -webkit-animation: spin-counter 1.5s infinite linear;
      -moz-animation: spin-counter 1.5s infinite linear;
      -o-animation: spin-counter 1.5s infinite linear;
      animation: spin-counter 1.5s infinite linear;
    }
    .fa-map-spin {
      -webkit-animation: fa-spin 1s infinite linear;
      -moz-animation: fa-spin 1s infinite linear;
      -o-animation: fa-spin 1s infinite linear;
      animation: fa-spin 1s infinite linear;
    }
    /*.fa-spin {
      -webkit-animation: spin-counter 3s infinite linear;
      -moz-animation: spin-counter 3s infinite linear;
      -o-animation: spin-counter 3s infinite linear;
      animation: spin-counter 3s infinite linear;
    }*/
    @-moz-keyframes spin-counter {
      0% {
        -moz-transform: rotate(359deg);
      }
      100% {
        -moz-transform: rotate(0deg);
      }
    }
    @-webkit-keyframes spin-counter {
      0% {
        -webkit-transform: rotate(359deg);
      }
      100% {
        -webkit-transform: rotate(0deg);
      }
    }
    @-o-keyframes spin-counter {
      0% {
        -o-transform: rotate(359deg);
      }
      100% {
        -o-transform: rotate(0deg);
      }
    }
    @-ms-keyframes spin-counter {
      0% {
        -ms-transform: rotate(359deg);
      }
      100% {
        -ms-transform: rotate(0deg);
      }
    }
    @keyframes spin-counter {
      0% {
        transform: rotate(359deg);
      }
      100% {
        transform: rotate(0deg);
      }
    }
</style>


// WEBPACK FOOTER //
// App.vue?558150e0